<template>
	<div class="download">
		<div class="title-box">
			<img src="@/assets/images/title_down.png"/>
		</div>
		<div class="main">
			<div class="in">
				<div class="left">
					<img class="title" src="@/assets/images/title_down_1.png"/>
					<div class="btns">
						<div class="btn ios" @click="download('ios')">
							<img src="@/assets/images/apple_w.png"/>
							<div class="text">
								<span class="t1">Download on the</span>
								<span class="t2">App Store</span>
							</div>
						</div>
						<div class="btn android" @click="download('android')">
							<img src="@/assets/images/android_g.png"/>
							<div class="text">
								<span class="t1">Download it from</span>
								<span class="t2">Android Market</span>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="@/assets/images/phone_home_v2.png"/>
				</div>
			</div>
		</div>
		<div class="btm-bg"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {
			download(type){
				if(type === 'android'){
					window.open('https://package.luyouxuan.com/package/LuYouXuan.apk')
				}else if(type === 'ios'){
					window.open('https://apps.apple.com/cn/app/id6636531470')
				}
			}
		},
	}
</script>

<style scoped lang="less">
	.download{
		padding-top: 0.9rem;
		background: #FBFBFB;
	}
	.title-box{
		margin-bottom: .6rem;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: .6rem;
		}
	}

	.btm-bg{
		height: 1.6rem;
		background:#F3405B url("../../assets/images/btm_down.png") no-repeat left center;
		background-size: auto 100%;
		position: relative;
		z-index: 1;
		margin-top: -1rem;
	}
	
	.main{
		position: relative;
		z-index: 2;
		.in{
			display: flex;
			flex-direction: column;
		}
		.left{
			padding-top: .1rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			.btns{
				display: flex;
				.btn{
					height: .5rem;
					border-radius: .04rem;
					display: flex;
					align-items: center;
					padding: 0 .1rem;
					box-sizing: border-box;
					margin: 0 .1rem;
					img{
						width: .3rem;
						height: auto;
						margin-right: .1rem;
					}
					.text{
						display: flex;
						flex-direction: column;
						.t1{
							font-size: .12rem;
							line-height: 1;
						}
						.t2{
							font-size: .16rem;
							line-height: 1;
						}
					}
				}
				.ios{
					background: #000000;
					.text{
						color:#fff;
					}
				}
				.android{
					border: #C0AEAE .01rem solid;
					.text{
						color:#000;
					}
				}
			}
			.title{
				width: auto;
				height: .8rem;
				margin-bottom: .6rem;
			}
		}
		.right{
			display: flex;
			justify-content: center;
			padding-top: .6rem;
			img{
				width: 100vw;
				height: auto;
				animation: floatAnimation 3s infinite;
			}
		}
	}
	
	@keyframes floatAnimation {
	  0% {
	    transform: translateY(0);
	  }
	  50% {
	    transform: translateY(30px);
	  }
	  100% {
	    transform: translateY(0);
	  }
	}
	
</style>